import { escapeHTML } from './dom-utils.js';

const PAGE_TYPES = {
  content: { short: 'Body', full: 'Body page' },
  table_of_contents: { short: 'ToC', full: 'Table of contents' },
  table_of_authorities: { short: 'ToA', full: 'Table of authorities' },
  title_page: { short: 'Title', full: 'Title page' },
};

function pageTypeInfo(page) {
  const type = String(page?.page_type || '').replace(/_with_footnotes$/, '');
  return PAGE_TYPES[type] ? { type, ...PAGE_TYPES[type] } : null;
}

export function pageTypeBadgeHtml(page) {
  const info = pageTypeInfo(page);
  if (!info) return '';

  const details = [info.full];
  if (page.page_type_source === 'jev') {
    const confidence = Number(page.page_type_confidence);
    details.push(Number.isFinite(confidence) ? `Jev ${Math.round(confidence * 100)}%` : 'Jev');
  } else if (page.page_type_source === 'rules') {
    details.push('page rules');
  }
  if (Number.isInteger(page.footnote_definition_count)) {
    const count = page.footnote_definition_count;
    details.push(`${count} footnote${count === 1 ? '' : 's'} detected`);
  }

  const className = info.type === 'content' ? 'page-type-badge' : 'page-type-badge page-type-badge--special';
  return `<span class="${className}" title="${escapeHTML(details.join(' · '))}">${info.short}</span>`;
}

export function pageJumpLabel(pageNumber, page) {
  const info = pageTypeInfo(page);
  return info ? `Page ${pageNumber} · ${info.short}` : `Page ${pageNumber}`;
}
